import { AnalyticsEventName } from 'src/modules/analytics/models/analytics-event-name.enum';

import { SideBarMenuItemGroup } from 'src/app/models/side-bar-menu-item-group';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';
import { AppFeatures } from 'src/app/enums/app-features.enum';
import { generalIopMenuItemsGroup } from 'src/app/components/side-bar/consts/general-iop-menu-items-group.const';

export const pscMenuItemsGroup: SideBarMenuItemGroup[] = [
  {
    label: 'General',
    menuItems: [
      {
        icon: 'search',
        routerLink: AppRouteEnum.PscSearch,
        name: 'PSC Search',
        hasSubNavs: true
      },
      ...generalIopMenuItemsGroup
    ]
  },
  {
    label: 'Tools',
    menuItems: [
      // {
      //   icon: 'report-data',
      //   routerLink: 'reports',
      //   name: 'Reports / Data'
      // },
      {
        icon: 'price-estimator',
        routerLink: 'price-estimator',
        gaEvent: AnalyticsEventName.PriceEstimatorNavClick,
        name: 'Price Estimator'
      },
      {
        icon: 'order',
        routerLink: 'supply-orders',
        gaEvent: AnalyticsEventName.SupplyOrdersNavClick,
        name: 'Supply Orders',
        feature: AppFeatures.SupplyOrders
      },
      {
        icon: 'book',
        routerLink: AppRouteEnum.TestCompendium,
        gaEvent: AnalyticsEventName.TestCompendiumNavClick,
        name: 'Test Compendium'
      },
      {
        icon: 'comment',
        routerLink: AppRouteEnum.Chat,
        name: 'Chat',
        feature: AppFeatures.Analytics
      }
    ]
  }
];
